import React from 'react'
import {Col, Row, Space} from "antd";
import {Link, withRouter} from "react-router-dom";
import {Footer} from "antd/es/layout/layout";

class MainFooter extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { location } = this.props;

    if (location.pathname === "/login" || location.pathname === "/signup" || location.pathname === "/nickname") {
      return null
    } else {
      return <Footer style={{ textAlign: 'center' }}>E-portfolio ©2021-2026</Footer>
    }
  }
}


export default withRouter(MainFooter)



          